import {
  LINKEDIN_VOL_IDENTITY_PROFILE_ID_KEY,
  LINKEDIN_VOL_POST_VERIFY_RETURN_PATH_KEY,
} from '@/constants/linkedin-vol';
import { deleteCookie, setBrowserCookie } from '@/utils/cookies';

const RETURN_MAX_AGE_SEC = 600;

/**
 * The identity journey can leave the app for LinkedIn's government-ID flow
 * (CLEAR/Persona), which takes longer than a plain OAuth round trip — give its
 * cookies a longer shelf life so the return leg still finds them.
 */
export const IDENTITY_JOURNEY_MAX_AGE_SEC = 1800;

/**
 * Short-lived cookie read by `/api/linkedin-vol/oauth-callback` so the server can
 * 302 back to the project after LinkedIn OAuth (pre-apply flow).
 */
export function setLinkedinVolReturnPathCookie(
  returnPath: string,
  maxAgeSeconds: number = RETURN_MAX_AGE_SEC,
): void {
  setBrowserCookie(LINKEDIN_VOL_POST_VERIFY_RETURN_PATH_KEY, returnPath, {
    maxAgeSeconds,
  });
}

export function clearLinkedinVolReturnPathCookie(): void {
  deleteCookie(LINKEDIN_VOL_POST_VERIFY_RETURN_PATH_KEY);
}

/**
 * Short-lived cookie read by `/api/linkedin-vol/verify-identity-return` so the
 * server can re-enter the OAuth flow (intent=identity_recheck) for the right
 * profile when LinkedIn sends the member back after government-ID verification.
 */
export function setLinkedinVolIdentityProfileIdCookie(profileId: string): void {
  setBrowserCookie(LINKEDIN_VOL_IDENTITY_PROFILE_ID_KEY, profileId, {
    maxAgeSeconds: IDENTITY_JOURNEY_MAX_AGE_SEC,
  });
}

export function clearLinkedinVolIdentityProfileIdCookie(): void {
  deleteCookie(LINKEDIN_VOL_IDENTITY_PROFILE_ID_KEY);
}
